import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { DocumentTypeService } from '../document-type.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize, map, Observable } from 'rxjs';
import { IAddDocumentTypePayload, IFormDocumentType } from '../document-type.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { DocumentCategoryService } from '../../document-category/document-category.service';

@Component({
    selector: 'app-add-document-type',
    templateUrl: './add-document-type.component.html',
    styleUrls: ['./add-document-type.component.scss']
})
export class AddDocumentTypeComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    documentCategories$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        categorie_id: new FormControl('-1', [Validators.required, Validators.min(0)]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddDocumentTypeComponent>,
        private documentTypeService: DocumentTypeService,
        private documentCategoryService: DocumentCategoryService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.loadDocumentCategories()
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    loadDocumentCategories() {
        this.isLoading = true;
        this.documentCategories$ = this.documentCategoryService.listDocumentCategory().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    submitForm() {
        this.isLoading = true;

        const { name, categorie_id, slug } = this.form.value as IFormDocumentType;
        const payload: IAddDocumentTypePayload = {
            name,
            categorie_id,
            slug
        };

        this.documentTypeService
            .addDocumentType(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
